import { useTranslation } from "react-i18next";
import { DeadlineDate, DeadlineWrapper } from "./styles";
import { DateTimeDeadlineProps } from "./types";

const DateTimeDeadline = ({ displayDate, dateTime }: DateTimeDeadlineProps) => {
  const { t } = useTranslation();

  return (
    <DeadlineWrapper>
      <span>{t("status.deadlineDateTimeLabel", "Deadline")}</span>
      <span>:</span>
      <DeadlineDate dateTime={dateTime}>{displayDate}</DeadlineDate>
    </DeadlineWrapper>
  );
};

export default DateTimeDeadline;
